import { SET_BBVA_PROPERTY, SET_BBVA_ACCOUNTS } from 'store/actions/bbva';
import { setValueObjectByField } from 'helpers/object';
// import { BBVA_TYPES_ACCOUNTS_ALLOWED } from 'store/enums';

export default {
  [SET_BBVA_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [SET_BBVA_ACCOUNTS]: (state, accounts) => {
    state.accounts = accounts
      .filter(item => item.operable) // && BBVA_TYPES_ACCOUNTS_ALLOWED.indexOf(item.type.toUpperCase()) > -1
      .map(account => {
        const { id, alias, description, number } = account;
        return {
          label: `${alias || description} ****${number}`,
          value: id
        };
      });
  }
};
